/* @flow */

import _timedScheduler from './timedscheduler';
import _immediateScheduler from './immediatescheduler';
import { logDebug } from './logger';
import { isValid } from './coreutils';

export const DEFAULT_SCHEDULER = 'immediate';
const FALLBACK_SCHEDULER = 'timed';

export function getSchedulerObj(
  currentScheduler: ?Scheduler = null
): Scheduler {
  // Always try immediate scheduler first
  let _builder = _immediateScheduler;
  let schedulerName = DEFAULT_SCHEDULER;

  // If current scheduler is already immediate, reuse it
  if (currentScheduler && currentScheduler.getName() === DEFAULT_SCHEDULER) {
    return currentScheduler;
  }

  // Check if immediate scheduler is supported, otherwise fallback to timed
  if (!isValid(_builder) || !_builder.isSupported()) {
    schedulerName = FALLBACK_SCHEDULER;
    _builder = _timedScheduler;
  }

  const o: Scheduler = new _builder(schedulerName);
  // $FlowFixMe
  logDebug(`Using Scheduler ${o.getName()}`);
  // $FlowFixMe
  return o;
}
